import * as React from 'react';
import { WidgetProps, ComponentProps } from '@intermix-dashboard/core';
import { useThemeObserver } from '../hooks/useThemeObserver';
import { getChartOptions } from '../../utils';

const Doughnut = React.lazy(() =>
  import('react-chartjs-2').then((module) => ({ default: module.Doughnut }))
);

export const IntermixDoughNutChartComponent: React.FC<ComponentProps> = ({
  data,
}) => {
  const { display } = useThemeObserver();

  return (
    <React.Suspense fallback="loading...">
      {display && <Doughnut data={data.rows} />}
    </React.Suspense>
  );
};

export const IntermixDoughNutChartWidget: WidgetProps = {
  id: 'expense-report',
  name: 'Expense Report',
  component: IntermixDoughNutChartComponent,
  view: {},
  options: { w: 3, h: 3, ...getChartOptions() },
};
